//
// uniquely identify a placement on supply side channels
// - if a placement is used in more than one supply channels and share the same look,
//   then we could use one placement type to represent them all
export const UAPPlacementType = {
  // mma
  MMA_WideImage_4x1: 'MMA_WideImage_4x1',
  MMA_LandscapeImage_191x100: 'MMA_LandscapeImage_191x100',
  MMA_SquareImage_1x1: 'MMA_SquareImage_1x1',
  MMA_VerticalImage_1x2: 'MMA_VerticalImage_1x2',

  // audience ad (mma in msan)
  Audience_Network_WideImage_191x100: 'Audience_Network_WideImage_191x100',
  Audience_Network_SquareImage_1x1: 'Audience_Network_SquareImage_1x1',
  Microsoft_Edge_Single_Carousel_178x100: 'Microsoft_Edge_Single_Carousel_178x100',
  MSN_InArticle_Ad_150x100: 'MSN_InArticle_Ad_150x100',
  MSN_Small_Headline_133x100: 'MSN_Small_Headline_133x100',

  // audience ad (mma in msan) V2
  MsanV2_Microsoft_Edge_Carouse_l201x100: 'MsanV2_Microsoft_Edge_Carouse_l201x100',
  MsanV2_Microsoft_Edge_Mobile_1x1: 'MsanV2_Microsoft_Edge_Mobile_1x1',
  MsanV2_MSAN_Banner_2x1: 'MsanV2_MSAN_Banner_2x1',
  MsanV2_MSAN_River_191x100: 'MsanV2_MSAN_River_191x100',
  MsanV2_MSAN_Rectangle_120x100: 'MsanV2_MSAN_Rectangle_120x100',
  MsanV2_MSAN_Rectangle_Image_191x100: 'MsanV2_MSAN_Rectangle_Image_191x100',
  MsanV2_MSN_Carousel_169x100: 'MsanV2_MSN_Carousel_169x100',
  MsanV2_MSN_Partner_Stripe_153x100: 'MsanV2_MSN_Partner_Stripe_153x100',
  MsanV2_MSN_Restoday_124x100: 'MsanV2_MSN_Restoday_124x100',

  // pmax
  PMax_MMA_WideImage_4x1: 'PMax_MMA_WideImage_4x1',
  PMax_MMA_LandscapeImage_191x100: 'PMax_MMA_LandscapeImage_191x100',
  PMax_MMA_VerticalImage_1x2: 'PMax_MMA_VerticalImage_1x2',
  PMax_Audience_Network_WideImage_191x100: 'PMax_Audience_Network_WideImage_191x100',
  PMax_Audience_Network_SquareImage_1x1: 'PMax_Audience_Network_SquareImage_1x1',
  PMax_Microsoft_Edge_Single_Carousel_178x100: 'PMax_Microsoft_Edge_Single_Carousel_178x100',
  PMax_MSN_InArticle_Ad_150x100: 'PMax_MSN_InArticle_Ad_150x100',
  PMax_MSN_Small_Headline_133x100: 'PMax_MSN_Small_Headline_133x100',
  // pmax v2
  PMax_MMAV2_Microsoft_Edge_Single_Carousel_201x100: 'PMax_MMAV2_Microsoft_Edge_Single_Carousel_201x100',
  PMax_MMAV2_MSN_Single_Carousel_169x100: 'PMax_MMAV2_MSN_Single_Carousel_169x100',
  PMax_MMAV2_MSN_Restoday_124x100: 'PMax_MMAV2_MSN_Restoday_124x100',
  PMax_MMAV2_MSN_Partner_Stripe_153x100: 'PMax_MMAV2_MSN_Partner_Stripe_153x100',
  PMax_MMAV2_MSN_River_191x100: 'PMax_MMAV2_MSN_River_191x100',
  PMax_Video: 'PMax_Video',
  PMax_MMAV2_Microsoft_Edge_Mobile_1x1: 'PMax_MMAV2_Microsoft_Edge_Mobile_1x1',

  // Boost
  Boost_Hero_Image_Carousel_200x100: 'Boost_Hero_Image_Carousel_200x100',
  Boost_Hero_Image_Carousel_122x100: 'Boost_Hero_Image_Carousel_122x100',
  Boost_Hero_Image_Carousel_159x100: 'Boost_Hero_Image_Carousel_159x100',
  Boost_Hero_Image_Carousel_180x100: 'Boost_Hero_Image_Carousel_180x100',
  Boost_Hero_Image_Carousel_233x100: 'Boost_Hero_Image_Carousel_233x100',
  Boost_Hero_Image_Carousel_320x100: 'Boost_Hero_Image_Carousel_320x100',
  Boost_Hero_Image_Carousel_57x100: 'Boost_Hero_Image_Carousel_57x100',
  Boost_Windows_Spotlight_191x100: 'Boost_Windows_Spotlight_191x100',
  Boost_Discover_Card_1x1: 'Boost_Discover_Card_1x1',
  Boost_Start_Menu: 'Boost_Start_Menu',
  Boost_Action_Center: 'Boost_Action_Center',
  Boost_Banner: 'Boost_Banner',
  Boost_Prong1_Prong2_Feed_191x100: 'Boost_Prong1_Prong2_Feed_191x100',
  Boost_Coachmark_175x100: 'Boost_Coachmark_175x100',

  // image extension
  ImgExt_MMAV2_MSN_River_191x100: 'ImgExt_MMAV2_MSN_River_191x100',
  ImgExt_MMAV2_MSN_Single_Carousel_169x100: 'ImgExt_MMAV2_MSN_Single_Carousel_169x100',
  ImgExt_MMAV2_MSN_Microsoft_Edge_Mobile_1x1: 'ImgExt_MMAV2_MSN_Microsoft_Edge_Mobile_1x1',
  ImgExt_Audience_Network_WideImage_191x100: 'ImgExt_Audience_Network_WideImage_191x100',
  ImgExt_Audience_Network_SquareImage_1x1: 'ImgExt_Audience_Network_SquareImage_1x1',
  ImgExt_Microsoft_Edge_Single_Carousel_178x100: 'ImgExt_Microsoft_Edge_Single_Carousel_178x100',
  ImgExt_Bing_Desktop_SingleImage_Extension_178x100: 'ImgExt_Bing_Desktop_SingleImage_Extension_178x100',
  ImgExt_Microsoft_Edge_Medium_Headline_172x100: 'ImgExt_Microsoft_Edge_Medium_Headline_172x100',
  ImgExt_MSN_Single_Carousel_169x100: 'ImgExt_MSN_Single_Carousel_169x100',
  ImgExt_MSN_Medium_Headline_155x100: 'ImgExt_MSN_Medium_Headline_155x100',
  ImgExt_MSN_InArticle_Ad_150x100: 'ImgExt_MSN_InArticle_Ad_150x100',
  ImgExt_MSN_Small_Headline_133x100: 'ImgExt_MSN_Small_Headline_133x100',
  ImgExt_Bing_Desktop_MultiImage_Extension_133x100: 'ImgExt_Bing_Desktop_MultiImage_Extension_133x100',
  ImgExt_Bing_Mobile_MultiImage_Extension_133x100: 'ImgExt_Bing_Mobile_MultiImage_Extension_133x100',
  ImgExt_MSN_Double_Carousel_93x100: 'ImgExt_MSN_Double_Carousel_93x100',

  // text ads
  Outlook_Text_Mobile: 'TextOutlookMobile',
  Outlook_Text_Web: 'TextOutlookWeb',
  Bing_Search_Mobile: 'BingTextMobile',
  Bing_Search_Desktop: 'BingTextDesktop',
  Bing_Search_Text: 'BingText',

  // responsive mma
  Responsive_MMA_WideImage_4x1: 'Responsive_MMA_WideImage_4x1',
  Responsive_MMA_LandscapeImage_191x100: 'Responsive_MMA_LandscapeImage_191x100',
  Responsive_MMA_SquareImage_1x1: 'Responsive_MMA_SquareImage_1x1',
  Responsive_MMA_VerticalImage_1x2: 'Responsive_MMA_VerticalImage_1x2',

  // responsive audience ad (mma in msan)
  Responsive_Audience_Network_WideImage_191x100: 'Responsive_Audience_Network_WideImage_191x100',
  Responsive_Audience_Network_SquareImage_1x1: 'Responsive_Audience_Network_SquareImage_1x1',
  Responsive_Microsoft_Edge_Single_Carousel_178x100: 'Responsive_Microsoft_Edge_Single_Carousel_178x100',
  Responsive_MSN_InArticle_Ad_150x100: 'Responsive_MSN_InArticle_Ad_150x100',
  Responsive_MSN_Small_Headline_133x100: 'Responsive_MSN_Small_Headline_133x100',

  // responsive audience ad (mma in msan) V2
  Responsive_MsanV2_Microsoft_Edge_Carouse_l201x100: 'Responsive_MsanV2_Microsoft_Edge_Carouse_l201x100',
  Responsive_MsanV2_Microsoft_Edge_Mobile_1x1: 'Responsive_MsanV2_Microsoft_Edge_Mobile_1x1',
  Responsive_MsanV2_MSAN_Banner_2x1: 'Responsive_MsanV2_MSAN_Banner_2x1',
  Responsive_MsanV2_MSAN_River_191x100: 'Responsive_MsanV2_MSAN_River_191x100',
  Responsive_MsanV2_MSAN_Rectangle_120x100: 'Responsive_MsanV2_MSAN_Rectangle_120x100',
  Responsive_MsanV2_MSN_Carousel_169x100: 'Responsive_MsanV2_MSN_Carousel_169x100',
  Responsive_MsanV2_MSN_Partner_Stripe_153x100: 'Responsive_MsanV2_MSN_Partner_Stripe_153x100',
  Responsive_MsanV2_MSN_Restoday_124x100: 'Responsive_MsanV2_MSN_Restoday_124x100',

  // responsive text ads
  Responsive_Outlook_Text_Mobile: 'ResponsiveTextOutlookMobile',
  Responsive_Outlook_Text_Web: 'ResponsiveTextOutlookWeb',
  Responsive_Bing_Search_Text: 'ResponsiveBingText',

  // responsive boost ads
  Responsive_Boost_Windows_Spotlight_191x100: 'Responsive_Boost_Windows_Spotlight_191x100',
  Responsive_Boost_Discover_Card_1x1: 'Responsive_Boost_Discover_Card_1x1',
  Responsive_Boost_Start_Menu: 'Responsive_Boost_Start_Menu',
  Responsive_Boost_Action_Center: 'Responsive_Boost_Action_Center',
  Responsive_Boost_Banner: 'Responsive_Boost_Banner',
  Responsive_Boost_Prong1_Prong2_Feed_191x100: 'Responsive_Boost_Prong1_Prong2_Feed_191x100',
  Responsive_Boost_Coachmark_175x100: 'Responsive_Boost_Coachmark_175x100',
  Responsive_Boost_Mini_Spotlight: 'Responsive_Boost_Mini_Spotlight',
  Responsive_Boost_Spotlight_Portrait: 'Responsive_Boost_Spotlight_Portrait',
  Responsive_Boost_Content_Hub: 'Responsive_Boost_Content_Hub',
  Responsive_Boost_Microsoft_Plus: 'Responsive_Boost_Microsoft_Plus',

  // responsive search ads
  Responsive_Search: 'ResponsiveSearch',
  Responsive_Search_Desktop: 'ResponsiveSearchDesktop',
  Responsive_Search_Mobile: 'ResponsiveSearchMobile',

  // responsive pmax
  Responsive_PMax_MMA_WideImage_4x1: 'Responsive_PMax_MMA_WideImage_4x1',
  Responsive_PMax_MMA_LandscapeImage_191x100: 'Responsive_PMax_MMA_LandscapeImage_191x100',
  Responsive_PMax_MMA_VerticalImage_1x2: 'Responsive_PMax_MMA_VerticalImage_1x2',
  Responsive_PMax_Audience_Network_WideImage_191x100: 'Responsive_PMax_Audience_Network_WideImage_191x100',
  Responsive_PMax_Audience_Network_SquareImage_1x1: 'Responsive_PMax_Audience_Network_SquareImage_1x1',
  Responsive_PMax_Microsoft_Edge_Single_Carousel_178x100: 'Responsive_PMax_Microsoft_Edge_Single_Carousel_178x100',
  Responsive_PMax_MSN_InArticle_Ad_150x100: 'Responsive_PMax_MSN_InArticle_Ad_150x100',
  Responsive_PMax_MSN_Small_Headline_133x100: 'Responsive_PMax_MSN_Small_Headline_133x100',
  // responsive pmax v2
  Responsive_PMax_MMAV2_Microsoft_Edge_Single_Carousel_201x100: 'Responsive_PMax_MMAV2_Microsoft_Edge_Single_Carousel_201x100',
  Responsive_PMax_MMAV2_MSN_Single_Carousel_169x100: 'Responsive_PMax_MMAV2_MSN_Single_Carousel_169x100',
  Responsive_PMax_MMAV2_MSN_Restoday_124x100: 'Responsive_PMax_MMAV2_MSN_Restoday_124x100',
  Responsive_PMax_MMAV2_MSN_Partner_Stripe_153x100: 'Responsive_PMax_MMAV2_MSN_Partner_Stripe_153x100',
  Responsive_PMax_MMAV2_MSN_River_191x100: 'Responsive_PMax_MMAV2_MSN_River_191x100',
  Responsive_PMax_MMAV2_Microsoft_Edge_Mobile_1x1: 'Responsive_PMax_MMAV2_Microsoft_Edge_Mobile_1x1',

  // dynamic search ads
  Dynamic_Search: 'DynamicSearch',

  // linkedin ads
  LinkedIn_Single_Image_Desktop_Landscape: 'LinkedIn_Single_Image_Desktop_Landscape',
  LinkedIn_Single_Image_Mobile_Landscape: 'LinkedIn_Single_Image_Mobile_Landscape',
  LinkedIn_Single_Image_Medium_Rectangle_Landscape: 'LinkedIn_Single_Image_Medium_Rectangle_Landscape',
  LinkedIn_Single_Image_Mobile_Interstitial_Landscape: 'LinkedIn_Single_Image_Mobile_Interstitial_Landscape',
  LinkedIn_Single_Image_Native_Landscape: 'LinkedIn_Single_Image_Native_Landscape',

  LinkedIn_Single_Image_Desktop_Square: 'LinkedIn_Single_Image_Desktop_Square',
  LinkedIn_Single_Image_Mobile_Square: 'LinkedIn_Single_Image_Mobile_Square',
  LinkedIn_Single_Image_Medium_Rectangle_Square: 'LinkedIn_Single_Image_Medium_Rectangle_Square',
  LinkedIn_Single_Image_Mobile_Interstitial_Square: 'LinkedIn_Single_Image_Mobile_Interstitial_Square',
  LinkedIn_Single_Image_Native_Square: 'LinkedIn_Single_Image_Native_Square',

  LinkedIn_Single_Image_Mobile_Vertical: 'LinkedIn_Single_Image_Mobile_Vertical',
  LinkedIn_Single_Image_Medium_Rectangle_Vertical: 'LinkedIn_Single_Image_Medium_Rectangle_Vertical',
  LinkedIn_Single_Image_Mobile_Interstitial_Vertical: 'LinkedIn_Single_Image_Mobile_Interstitial_Vertical',
  LinkedIn_Single_Image_Native_Vertical: 'LinkedIn_Single_Image_Native_Vertical',

  Unified_App_Ads_Video_Horizontal: 'Unified_App_Ads_Video_Horizontal',
  Unified_App_Ads_Bing_Search: 'Unified_App_Ads_Bing_Search',
  Unified_App_Ads_Bing_Search_Text: 'Unified_App_Ads_Bing_Search_Text',
  Unified_App_Ads_Causal_Games_Dimensions: 'Unified_App_Ads_Causal_Games_Dimensions',
  Unified_App_Ads_M365_Outlook: 'Unified_App_Ads_M365_Outlook',
  Unified_App_Ads_MSN_Display: 'Unified_App_Ads_MSN_Display',
  // todo: video
};
